<template>
  <div class="box-ss">
    <el-tabs v-model="activeName">
      <el-tab-pane label="基本信息" name="first">
        <info></info>
      </el-tab-pane>
      <el-tab-pane label="风险物质" name="second">
        <!-- 分组表格 -->
        <div v-if="hasSubstanceType" class="grouped-table-container">
          <el-card v-for="(group, index) in groupedData" :key="index" class="group-card">
            <template v-if="group.type" slot="header">
              <div class="card-header">
                <span>{{ formatSubstanceType(group.type) }}</span>
                <span class="q-value">Q值合计: {{ group.total.toFixed(2) }}</span>
              </div>
            </template>
            <el-table
              :data="group.items"
              border
              style="width: 100%"
              :ref="'groupTable' + index"
              class="sync-scroll"
              :show-header="index === 0">
              <el-table-column type="index">
              </el-table-column>
              <el-table-column prop="cas" label="CAS号">
              </el-table-column>
              <el-table-column prop="name" label="物质名称">
              </el-table-column>
              <el-table-column prop="criticalValue" label="临界量(吨)">
              </el-table-column>
              <el-table-column prop="state" label="形态">
                <template slot-scope="scope">
                  {{ formatState(scope.row.state) }}
                </template>
              </el-table-column>
              <el-table-column prop="count" label="最大存储量(吨)">
              </el-table-column>
              <el-table-column prop="purity" label="折纯量(吨)">
              </el-table-column>
              <el-table-column prop="remark" label="补充说明">
              </el-table-column>
              <el-table-column prop="qValue" label="Q值">
              </el-table-column>
            </el-table>
          </el-card>
        </div>

        <!-- 非分组表格 -->
        <div v-else class="normal-table-container">
          <el-table :data="materialdetail" border style="width: 100%">
            <el-table-column type="index">
            </el-table-column>
            <el-table-column prop="name" label="物质名称">
            </el-table-column>
            <el-table-column prop="cas" label="CAS号">
            </el-table-column>
            <el-table-column prop="state" label="形态">
              <template slot-scope="scope">
                {{ formatState(scope.row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="count" label="数量(吨)">
            </el-table-column>
            <el-table-column prop="criticalValue" label="临界量(吨)">
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="应急物资" name="third">
        <detailone></detailone>
      </el-tab-pane>
      <!-- <el-tab-pane label="工艺和环境风险控制" name="fourth">
        <process></process>
      </el-tab-pane> -->
      <el-tab-pane label="应急队伍" name="fifth">
        <el-table :data="teamData" border style="width: 100%" height="585">
          <el-table-column label="单位名称" prop="orgName">
          </el-table-column>
          <el-table-column label="联系人" prop="linkman">
          </el-table-column>
          <el-table-column label="联系电话" prop="phone">
          </el-table-column>
          <el-table-column label="处置能力" prop="description">
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="敏感保护目标区域" name="sixth">
        <sensprotection></sensprotection>
      </el-tab-pane>
      <el-tab-pane label="案例" name="seventh">
        <casev></casev>
      </el-tab-pane>
      <el-tab-pane label="平面图" name="eighth">
        <planimg></planimg>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import workbrnch from './../../data/emer/burst.js'
import detailone from './../digtization/detail_one.vue'
import process from './../digtization/process.vue'
import info from './../digtization/infovue.vue'
import sensprotection from './../digtization/Sensprotection.vue'
import planimg from './../digtization/planimg.vue'
import casev from './../digtization/casev.vue'
export default {
  components: {
    detailone,
    process,
    info,
    sensprotection,
    planimg,
    casev
  },
  data() {
    return {
      activeName: 'first',
      // 基本信息
      infodetail: [],
      // 风险物质
      materialdetail: [],
      // 应急物质
      supplydetail: [],
      detailsupply: [],
      // 机构ID
      planId: '',
      teamData: [],
      hasSubstanceType: false,
      groupedData: [], // 用于存储分组后的数据
      substanceTypeOptions: [{
        label: 1,
        name: '涉水风险物质'
      }, {
        label: 2,
        name: '涉气风险物质'
      }],
      scrollHandlers: [] // 用于存储滚动事件处理器
    }
  },
  created() {
    if (!sessionStorage.planIdLists) return
    this.planId = sessionStorage.planIdLists
    this.material_lists()
    this.team_lists()
  },
  mounted() {
    this.$nextTick(() => {
      this.initScrollSync();
    });
  },
  watch: {
    groupedData: {
      handler() {
        this.$nextTick(() => {
          this.initScrollSync();
        });
      },
      deep: true
    }
  },
  methods: {
    // changeArr(data) {
    //   if (!data) return
    //   let arrlist = data
    //   let arr = []
    //   let arrr = ''
    //   arr = Array.from(arrlist.split(','), i => parseInt(i))
    //   arr.map((item, index) => {
    //     arrr += '<span>' + ++index + this.getTxt(item) + '</span>'
    //   })
    //   return arrr
    // },
    // // 得到列表字数据
    // getTxt(data) {
    //   let stateTxt = ''
    //   switch (data) {
    //     case 1:
    //       stateTxt = '火灾、爆炸、泄漏等生产安全事故及可能引起的次生、衍生 厂外环境污染及人员伤亡事故（例如，因生产安全事故导致有毒有 害气体扩散出厂界，消防水、物料泄漏物及反应生成物，从雨水排 口、清净下水排口、污水排口、厂门或围墙排出厂界，污染环境等）'
    //       break;
    //     case 2:
    //       stateTxt = '环境风险防控设施失灵或非正常操作（如雨水阀门不能正常'
    //       break;
    //     case 3:
    //       stateTxt = '非正常工况（如开、停车等）'
    //       break;
    //     case 4:
    //       stateTxt = '污染治理设施非正常运行'
    //       break;
    //     case 5:
    //       stateTxt = '违法排污'
    //       break
    //     case 6:
    //       stateTxt = '停电、断水、停气等'
    //       break;
    //     case 7:
    //       stateTxt = '通讯或运输系统故障'
    //       break;
    //     case 8:
    //       stateTxt = '各种自然灾害、极端天气或不利气象条件；'
    //       break;
    //     case 9:
    //       stateTxt = '其他可能的情景。'
    //       break;
    //   }
    //   return stateTxt
    // },
    // 形态
    formatState(state) {
      let res = ''
      switch (state) {
        case 1:
          res = '固态'
          break
        case 3:
          res = '气态'
          break
        case 2:
          res = '液态'
          break
      }
      return res
    },
    // 选中
    change(item, index) {
      this.selectIndex = index
    },
    // 风险物质
    material_lists() {
      (async() => {
        try {
          let info = await workbrnch.material_lists({
            planId: this.planId
          })
          if (info.status && info.data) {
            this.materialdetail = info.data
            this.checkAndProcessTableData()
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
    // 检查并处理表格数据
    checkAndProcessTableData() {
      // 检查是否有物质类型数据
      this.hasSubstanceType = this.materialdetail.some(item => item.substanceType);

      if (this.hasSubstanceType) {
        this.processTableData();
      }
    },
    // 处理表格数据，计算Q值合计和分组信息
    processTableData() {
      // 按物质类型分组
      const groups = {};
      this.materialdetail.forEach(item => {
        if (!groups[item.substanceType]) {
          groups[item.substanceType] = {
            type: item.substanceType,
            items: [],
            total: 0
          };
        }
        groups[item.substanceType].items.push(item);
        groups[item.substanceType].total += Number(item.qValue || 0);
      });

      // 转换为数组并排序
      this.groupedData = Object.values(groups).sort((a, b) => a.type - b.type);
    },
    formatSubstanceType(substanceType) {
      const substanceTypeOption = this.substanceTypeOptions.find(option => option.label === substanceType);
      return substanceTypeOption ? substanceTypeOption.name : '';
    },
    formatRiskType(riskType) {
      const riskTypeMap = {
        '1': '第一部分 有毒气态物质',
        '2': '第二部分 易燃易爆气态物质',
        '3': '第三部分 有毒液态物质',
        '4': '第四部分 易燃液态物质',
        '5': '第五部分 其他有毒物质',
        '6': '第六部分 遇水生成有毒气体的物质',
        '7': '第七部分 重金属及其化合物',
        '8': '第八部分 其他类物质及污染物'
      };
      return riskTypeMap[riskType] || riskType;
    },
    // 风险物质
    team_lists() {
      (async() => {
        try {
          let info = await workbrnch.get_team_lists({
            planId: this.planId
          })
          if (info.status) {
            this.teamData = info.data.externalEmergencyTeam
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
    initScrollSync() {
      // 清除之前的滚动事件监听器
      this.clearScrollHandlers();

      // 获取所有分组表格
      const tables = [];
      for (let i = 0; i < this.groupedData.length; i++) {
        const tableRef = this.$refs['groupTable' + i];
        if (tableRef) {
          const table = Array.isArray(tableRef) ? tableRef[0] : tableRef;
          if (table) {
            tables.push(table);
          }
        }
      }

      if (tables.length === 0) return;

      // 为每个表格添加滚动事件监听
      tables.forEach(table => {
        const bodyWrapper = table.$el.querySelector('.el-table__body-wrapper');
        if (bodyWrapper) {
          const handler = (e) => {
            const scrollLeft = e.target.scrollLeft;
            // 同步其他表格的滚动位置
            tables.forEach(otherTable => {
              if (otherTable !== table) {
                const otherBodyWrapper = otherTable.$el.querySelector('.el-table__body-wrapper');
                if (otherBodyWrapper) {
                  otherBodyWrapper.scrollLeft = scrollLeft;
                }
              }
            });
          };

          bodyWrapper.addEventListener('scroll', handler);
          this.scrollHandlers.push({ element: bodyWrapper, handler });
        }
      });
    },
    clearScrollHandlers() {
      this.scrollHandlers.forEach(({ element, handler }) => {
        element.removeEventListener('scroll', handler);
      });
      this.scrollHandlers = [];
    },
  },
  beforeDestroy() {
    this.clearScrollHandlers();
  },
}

</script>
<style scoped lang="stylus">
.box-d1 {
  p {
    line-height: 25px;
    font-size: 14px;
  }
}

.grouped-table-container {
  margin-top: 0px;
}

.group-card {
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
}

.group-card >>> .el-card__body {
  padding: 5px !important;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.group-card >>> .el-table {
  flex: 1;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.q-value {
  color: #409EFF;
  font-weight: bold;
}

.group-card >>> .el-card__header {
  padding: 8px 20px;
  border-bottom: 1px solid #d1dbe5;
  box-sizing: border-box;
}

.card-header span:first-child {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Digitization.vue?1d177c49